<template>
  <a-layout-sider
      collapsible
      v-model="toggleSidebarCollapse"
      :trigger="null"
  >
    <template>
      <div class="logo" v-if="!toggleSidebarCollapse">
        <img :src="require('@/assets/wemail.svg')" alt height="20px" width="20px"> WeMail
      </div>
      <div class="logo" v-else>
        <img src="@/assets/wemail.svg" alt height="25px" width="25px">
      </div>
    </template>
    <a-menu
        theme="dark"
        mode="inline"
        :default-selected-keys="[activePage]"
        :default-open-keys="[activePage]"
    >
      <a-menu-item key="/admin" v-if="isAdmin() || isDeveloper() || isAnalyst()">
        <router-link to="/admin">
          <a-icon type="dashboard"/><span v-if="!toggleSidebarCollapse">Dashboard</span>
        </router-link>
      </a-menu-item>
      <a-sub-menu
          :key="childKeys(['/admin/sites', '/admin/sites/top', '/admin/sites/paid', '/admin/sites/deletion-request'])"
      >
        <span slot="title"><a-icon type="global"/><span>Sites</span></span>
        <a-menu-item key="/admin/sites" v-if="isAdmin()">
          <router-link to="/admin/sites">
            <a-icon type="global"/><span v-if="!toggleSidebarCollapse">Sites</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/admin/sites/top" v-if="isAdmin()">
          <router-link to="/admin/sites/top">
            <a-icon type="rise" /><span v-if="!toggleSidebarCollapse">Top Sites</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/admin/sites/paid" v-if="isAdmin()">
          <router-link to="/admin/sites/paid">
            <a-icon type="crown" /><span v-if="!toggleSidebarCollapse">Permium Sites</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/admin/sites/deletion-request" v-if="isAdmin()">
          <router-link :to="{name: 'sites.data.deletion'}">
            <a-icon type="delete" /><span v-if="!toggleSidebarCollapse">Deletion Request</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/admin/sites/search-site" v-if="isAdmin()">
          <router-link :to="{name: 'sites.search-site'}">
            <a-icon type="question-circle" /><span v-if="!toggleSidebarCollapse">Find Site</span>
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/admin/campaigns" v-if="isAdmin()">
        <router-link to="/admin/campaigns">
          <a-icon type="schedule"/><span v-if="!toggleSidebarCollapse">Campaigns</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/coupons" v-if="isAdmin()">
        <router-link to="/admin/coupons">
          <a-icon type="dollar"/><span v-if="!toggleSidebarCollapse">Coupons</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/notice-boards" v-if="isAdmin()">
        <router-link to="/admin/notice-boards">
          <a-icon type="pushpin"/><span v-if="!toggleSidebarCollapse">Notice Boards</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/users" v-if="isAdmin()">
        <router-link to="/admin/users">
          <a-icon type="dashboard"/><span v-if="!toggleSidebarCollapse">Users</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/site-users" v-if="isAdmin()">
        <router-link to="/admin/site-users">
          <a-icon type="user"/><span v-if="!toggleSidebarCollapse">Site Users</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/stats" v-if="isAdmin() || isAnalyst()">
        <router-link to="/admin/stats">
          <a-icon type="bar-chart"/><span v-if="!toggleSidebarCollapse">Stats</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/servers" v-if="isAdmin()">
        <router-link to="/admin/servers">
          <a-icon type="database"/><span v-if="!toggleSidebarCollapse">Servers</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/event-logs/all" v-if="isAdmin() || isDeveloper()">
        <router-link to="/admin/event-logs">
          <a-icon type="question-circle"/><span v-if="!toggleSidebarCollapse">Event & Logs</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/admin/subscription-calcels" v-if="isAdmin() || isDeveloper()">
        <router-link :to="{name: 'subscription.calcels'}">
          <a-icon type="close-circle"/><span v-if="!toggleSidebarCollapse">Subscription Cancels</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="/change-password" v-if="isAdmin() || isDeveloper() || isAnalyst()">
        <router-link to="/change-password">
          <a-icon type="setting"/><span v-if="!toggleSidebarCollapse">Change Password</span>
        </router-link>
      </a-menu-item>
      <a-menu-item key="logout" @click="logout" v-if="isAdmin() || isDeveloper() || isAnalyst()">
        <a-icon type="logout"/>
        <span>Logout</span>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
</template>
<script>
import localforage from 'localforage';
import {mapState} from "vuex";
export default {
  data() {
    return {
      toggleSidebarCollapse: false,
      activePage: ""
    };
  },
  computed: {
    ...mapState('auth', ["role"]),
  },
  methods: {
    async logout() {
      await this.$store.dispatch("auth/logout");
      localforage.removeItem('authtoken').then(() => {
        this.$weNotify("success", "Logout Successful!");
        this.$router.push("/login");
      });
    },
    toggleSidebar() {
      this.$store.commit("SIDEBAR_COLLAPSE");
    },
    isAdmin() {
      return this.role === 'wemail_admin';
    },
    isDeveloper() {
      return this.role === 'wemail_developer';
    },
    isAnalyst() {
      return this.role === 'wemail_analyst';
    },
    handleResize() {
      if(window.innerWidth < 767) {
        this.toggleSidebarCollapse = true;
        this.$store.commit("SIDEBAR_COLLAPSE", true);
      } else {
        this.toggleSidebarCollapse = false;
        this.$store.commit("SIDEBAR_COLLAPSE");
      }
    },
    childKeys(keys) {
      for (let i = 0; i < keys.length; i++) {
        if (this.activePage === keys[i]) {
          return this.activePage;
        }
      }
      return Math.random().toString(5);
    }
  },
  created() {
    this.activePage = this.$route.fullPath;

    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      this.activePage = newRoute.fullPath;
    }
  },
};
</script>
<style >
.trigger anticon anticon-menu-fold {
  color: #ffffff;
}
</style>


